@import 'styles/mixins';
@import 'styles/variables';

$tabBarHeight: 35px;

.root {
  user-select: none;
}

.topEmptySpace {
  height: 0;
  width: 100vw;
  -webkit-app-region: drag;
  app-region: drag;

  &.wco {
    height: calc(max(0px, env(titlebar-area-height, $tabBarHeight) - $tabBarHeight - 3px));
    padding-top: 3px;
  }
}

.topBar {
  display: flex;
  height: $tabBarHeight;
  align-items: center;

  // For "window-controls-overlay" display mode
  margin-left: env(titlebar-area-x, 0);
  margin-right: calc(100vw - env(titlebar-area-x, 0) - env(titlebar-area-width, 0));
}

.tabs {
  display: flex;
  position: relative;
  flex: 1;
  height: 100%;

  overflow-y: hidden;
  overflow-x: scroll;
  @include hide-scrollbar;
  overscroll-behavior: contain; // prevent history navigation when the user overscrolls, e.g. with a trackpad.

  &.leftShadow::before {
    content: '';
    position: sticky;
    left: 0;
    display: block;
    height: $tabBarHeight;
    width: 15px;
    z-index: 2;
    box-shadow: 30px 0px 15px -30px rgba(0, 0, 0, 0.25) inset;
  }
  &.rightShadow::after {
    content: '';
    position: sticky;
    left: calc(100% - 15px);
    display: block;
    height: $tabBarHeight;
    width: 15px;
    z-index: 2;
    box-shadow: -30px 0px 15px -30px rgba(0, 0, 0, 0.25) inset;
  }
}

.draggableEmptySpace {
  -webkit-app-region: drag;
  app-region: drag;
  position: absolute;
  height: 100%;
  right: 0;
}

.betaBadge {
  -webkit-app-region: drag;
  app-region: drag;
  margin: 0 8px;
  padding: 0 8px;
  height: 22px;
  line-height: 22px;
  border-radius: 11px;
  color: $grey-50;
  border: 1px solid $grey-30;
  font-size: 12px;

  /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
  @media (min-resolution: 2x) {
    border: 0.5px solid $grey-40;
  }
}
